import { SVGProps } from 'react';
const IcProtect = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none' {...props}>
    <path
      d='M20.2635 9.38457C20.2635 14.8735 17.018 19.8291 12.0175 22.0334C7.01699 19.8291 3.77157 14.8735 3.77157 9.38457V5.37528L12.0175 1.95165L20.2635 5.37528V9.38457ZM22.1376 4.74971C22.1376 4.371 21.9096 4.02952 21.5598 3.88431L12.3768 0.0716095C12.1468 -0.0238857 11.8883 -0.0238838 11.6582 0.0716095L2.4752 3.88431C2.12544 4.02952 1.89747 4.371 1.89746 4.74971V9.38457C1.89746 15.7635 5.75746 21.5082 11.6634 23.9188L11.6848 23.9272C11.9063 24.0113 12.1517 24.0085 12.3716 23.9188C18.2775 21.5082 22.1376 15.7635 22.1376 9.38457V4.74971Z'
      fill={props.fill || '#232F3E'}
    />
    <path
      d='M9.91054 14.9673C10.2776 15.3162 10.8582 15.3106 11.2184 14.9504L15.9086 10.2603C16.2745 9.89433 16.2745 9.30104 15.9086 8.9351C15.5426 8.56916 14.9493 8.56913 14.5834 8.93507L10.5558 12.9626L8.59965 11.0065C8.23371 10.6405 7.64039 10.6405 7.27445 11.0065C6.90852 11.3724 6.90852 11.9657 7.27445 12.3317L9.89321 14.9504L9.91054 14.9673Z'
      fill={props.fill || '#232F3E'}
    />
  </svg>
);

export default IcProtect;
